export default "<app-header></app-header>\n\n<div class=\"content\">\n    <app-portfolio></app-portfolio>\n</div>"